import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Provider } from '../../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../../common/ComponentNameContext';
import Tab from '../../../common/tab';
import { getCurrentDate } from '../../../helpers/Common';
import withTabAndRealTime from '../common/withTabAndRealtime';
import { indexMapFilter } from '../Const';
import AllExchanges from './AllExchanges';
import { connect } from 'react-redux';
import {
  exportTopNewHighData,
  REDUCER_NAME,
  subscribeRealtimeTickTopNewHigh,
} from './reducer';
import ScrollComponent from './../../../common/ScrollComponent';
import { compose } from 'redux';
import PreRender from '../../../common/PreRender';
import ConstCommon from './../../../common/Const';
import Export from '../common/export-blob';
import TabTimer from '../../../common/tab-timer';
import DropDownTimeRange from './DropDownTimeRange';

const listTab = {
  1: 'Overview',
  2: 'Performance',
  3: 'Financial',
  4: 'Technical',
  5: 'Chart',
};

class TopNewHigh extends React.Component {
  getExportFunction() {
    const { typeTab, timeRange, exportTopNewHighData, indexTab } = this.props;

    if (typeTab === 5) return;
    const screen = listTab[typeTab];
    const filter = indexMapFilter[indexTab];
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopNewHigh'),
    })}`;

    return () => exportTopNewHighData(filter, screen, timeRange, name);
  }

  render() {
    const { indexTab, changeIndex, typeTab, changeType, id } = this.props;
    const exportOption = {
      exportFunction: this.getExportFunction(),
    };

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.TopNewHigh}>
            <ScrollComponent>
              <div
                className={`top-nav d-flex flex-column ${
                  typeTab === 5 ? '' : 'h-100'
                }`}
              >
                <div className={`px-20 pt-8 ${typeTab === 5 ? 'sticky' : ''}`}>
                  <Tab
                    currentTab={indexTab}
                    listTab="topVolume.tab"
                    changeTab={changeIndex}
                  />
                  <div className="d-flex justify-content-between list-filter top-nav">
                    <div className="d-flex">
                      <TabTimer
                        currentTab={typeTab}
                        listTab="topVolume.tabDataChange.tabDataChangeTab"
                        changeTab={changeType}
                      />
                      <div className="ml-1 mr-20" style={{ marginTop: '-5px' }}>
                        <DropDownTimeRange
                          comGroupCode={indexMapFilter[indexTab]}
                        />
                      </div>
                    </div>
                    <div style={{ paddingTop: 2 }}>
                      {typeTab !== 5 && <Export {...exportOption} />}
                    </div>
                  </div>
                </div>

                <div className="tab-content d-flex flex-column flex-fill">
                  <AllExchanges
                    key={indexTab}
                    typeTab={typeTab}
                    filter={indexMapFilter[indexTab]}
                  />
                </div>
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({
  timeRange: state[REDUCER_NAME].timeRange,
  i18n: state.i18n,
});

const mapDispatchToProps = {
  dispatchRealtime: subscribeRealtimeTickTopNewHigh,
  exportTopNewHighData,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withTabAndRealTime(ConstCommon.listComponent.TopNewHigh),
)(TopNewHigh);
